import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Select,
  Input,
  Radio,
  DatePicker,
  message,
  Switch,
} from "antd";
import { SearchOutlined, SendOutlined, CalendarOutlined } from "@ant-design/icons";
import moment from "moment";
import ModelWrapper from "../../../modal/ModelWrapper";
import { CustomButton, CustomSecondaryButton } from "../../physician_page/styled";
import { patientService, physicianService, ccmCoordinatorService } from "../../../../services/user";
import { notify } from "../../../../utils/helper";
import styled from "styled-components";
import AddPatientModal from "../../patients_page/AddPatientModal";
import journeyService from "../../../../services/journey";
import { extractToken } from "../../../../utils/localStorage";
import { globalRoles } from "../../../../utils/roles";

const { Option } = Select;
const { TextArea } = Input;

const ModalContent = styled.div`
  padding: 0 15px;
  max-height: 70vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .ant-form-item label {
    font-size: 14px;
    font-weight: 500;
  }
`;

const SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: var(--primary-text-color);
  margin-bottom: 12px;
  margin-top: 24px;

  &:first-child {
    margin-top: 0;
  }
`;

const DescriptionText = styled.div`
  font-size: 14px;
  color: var(--secondary-text-color);
  margin-bottom: 24px;
  line-height: 1.5;
`;

const PatientCard = styled.div`
  border-top: 1px solid var(--border-color);
  // border-radius: 6px;
  padding: 8px 12px;
  // margin-bottom: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: var(--primary-bg);

  &:hover {
    // border-color: #8a3ef4;
    background-color: var(--secondary-bg);
  }

  ${(props) =>
    props.selected &&
    `
    // border-color: #8a3ef4;
    background-color: rgba(138, 62, 244, 0.1);
  `}
`;

const PatientName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-text-color);
  margin-bottom: 2px;
  line-height: 1.3;
`;

const PatientInfo = styled.div`
  font-size: 12px;
  color: var(--secondary-text-color);
  margin-bottom: 1px;
  line-height: 1.3;

  &:last-child {
    margin-bottom: 0;
  }
`;

const PatientInfoContainer = styled.div`
  padding: 16px;
  background-color: var(--secondary-bg);
  border-radius: 8px;
  margin-bottom: 24px;
  margin-top: 8px;
`;

const PatientInfoRow = styled.div`
  font-size: 14px;
  color: var(--secondary-text-color);
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledRadioGroup = styled(Radio.Group)`
  
  display: flex !important;
  flex-direction: column !important;

  .ant-radio-wrapper {
    color: var(--primary-text-color);
    font-size: 14px;
    margin-bottom: 2px;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #8a3ef4;
  }

  .ant-radio-inner::after {
    background-color: #8a3ef4;
  }

  .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: #8a3ef4;
  }
`;

const SearchInput = styled(Input)`
  margin-top: 12px;

  &.ant-input-affix-wrapper {
    height: 40px;
    border-radius: 6px;
    background-color: var(--primary-bg);
    border: 1px solid var(--border-color) !important;
    color: var(--primary-text-color);
    box-shadow: none !important;

    &:hover,
    &:focus,
    &.ant-input-affix-wrapper-focused {
      border-color: #8a3ef4 !important;
    }

    .ant-input {
      background-color: var(--primary-bg);
      color: var(--primary-text-color);
      height: auto;
    }
  }
`;

const PatientListContainer = styled.div`
  margin-top: 10px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-color);
  border-radius: 6px;

  &::-webkit-scrollbar {
    width: 8px;
    background-color: #eeeeee;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
`;

const SelectedPatientBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding: 10px 14px;
  background: rgba(138, 62, 244, 0.08);
  border: 1.5px solid #8a3ef4;
  border-radius: 6px;
  gap: 12px;
`;

const SelectedPatientInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const SelectedPatientName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SelectedPatientMeta = styled.div`
  font-size: 12px;
  color: var(--secondary-text-color);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ChangePatientButton = styled.button`
  flex-shrink: 0;
  background: none;
  border: 1px solid #8a3ef4;
  color: #8a3ef4;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #8a3ef4;
    color: #fff;
  }
`;

const StyledSelect = styled(Select)`
  width: 100%;
  .ant-select-selector {
    height: 40px !important;
    border-radius: 6px !important;
    background-color: var(--primary-bg) !important;
    border: 1px solid var(--border-color) !important;
  }

  .ant-select-selection-item {
    line-height: 38px !important;
    color: var(--primary-text-color);
    font-size: 15px;
  }

  &:hover .ant-select-selector {
    border-color: #8a3ef4 !important;
  }
`;

const StyledTextArea = styled(TextArea)`
  background-color: var(--primary-bg);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--primary-text-color);
  min-height: 100px;

  &:hover,
  &:focus {
    border-color: #8a3ef4;
  }

  &::placeholder {
    color: var(--secondary-text-color);
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  height: 40px;
  border-radius: 6px;
  background-color: var(--primary-bg);
  border: 1px solid var(--border-color);

  &:hover,
  &:focus {
    border-color: #8a3ef4;
  }

  .ant-picker-input > input {
    color: var(--primary-text-color);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--border-color);
`;

const AssignJourneyModal = ({ isOpen, setOpen, journeyId, onSuccess, selectedClinicalId, setSelectedClinicalId, journeyData }) => {
  const [form] = Form.useForm();
  const user = extractToken();
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientSelectionType, setPatientSelectionType] = useState("existing");
  const [isAddPatientModalOpen, setIsAddPatientModalOpen] = useState(false);
  const [enableReminder, setEnableReminder] = useState(false);
  const [scheduleType, setScheduleType] = useState("immediate");
  const [journeyTemplates, setJourneyTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [allPhysicians, setAllPhysicians] = useState([]);
  const [allCoordinator, setAllCoordinator] = useState([]);

  const sendMethodOptions = [
    { value: "both", label: "Both (Email & SMS)" },
    { value: "sms", label: "TEXT/SMS" },
    { value: "email", label: "Email" },
  ];

  const reminderFrequencyOptions = [
    // { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];

  const fetchJourneyTemplates = async () => {
    try {
      setLoadingTemplates(true);
      // TODO: Replace with actual journey template API call
      // const response = await journeyService.getTemplates();
      // if (response?.data?.results) {
      //   setJourneyTemplates(response.data.results);
      // } else {
      //   setJourneyTemplates([]);
      // }

      // Placeholder data - remove when API is ready
      setJourneyTemplates([
        {
          id: 1,
          name: "Cardiac Care Education",
          description: "Educational journey preparing patient for procedure",
        },
        {
          id: 2,
          name: "Childhood Asthma Management",
          description: "Educational journey for parents",
        },
        {
          id: 3,
          name: "Diabetes Management",
          description: "Comprehensive diabetes care plan",
        },
      ]);
    } catch (error) {
      notify("error", "Failed to load journey templates");
      setJourneyTemplates([]);
    } finally {
      setLoadingTemplates(false);
    }
  };

  const fetchPatients = async (searchInput = "") => {
    const isClinical = journeyData?.type === "clinical";

    const clinicalParam = isClinical ? "true" : "";
    const ccmParam = isClinical ? "" : "true";
    try {
      setLoading(true);
      const response = await patientService.getAll(
        100, 
        1, 
        searchInput, 
        "",
        clinicalParam,
        ccmParam,
      );
      if (response?.data?.results) {
        const patientData = response?.data?.results || [];
        const assignedPatientIds = journeyData?.assignedPatients.map((a) => a.patientId.id) || [];
        const filteredPatient = patientData.filter((p) => !assignedPatientIds.includes(p.id));
        setPatients(filteredPatient);
      } else {
        setPatients([]);
      }
    } catch (error) {
      notify("error", "Failed to load patients");
      setPatients([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchPatients();
      fetchJourneyTemplates();
      // Reset form when modal opens
      form.resetFields();
      setSelectedPatient(null);
      setSearchText("");
      setPatientSelectionType("existing");
    
      setScheduleType("immediate");
    }
  }, [isOpen]);

  useEffect(() => {
    if (patientSelectionType === "existing") {
      fetchPatients(searchText);
    }
  }, [searchText, patientSelectionType]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handlePatientSelect = (patient) => {
    setSelectedPatient(patient);
    form.setFieldsValue({
      patientId: patient.id,
    });
  };

  const handlePatientCreated = async (newPatientId) => {
    if (newPatientId) {
      setIsAddPatientModalOpen(false);
      setPatientSelectionType("existing");

      const isClinical = journeyData?.type === "clinical";
      const clinicalParam = isClinical ? "true" : "";
      const ccmParam = isClinical ? "" : "true";

      try {
        setLoading(true);
        const response = await patientService.getAll(100, 1, "", "", clinicalParam, ccmParam);
        if (response?.data?.results) {
          const patientData = response.data.results;
          const assignedPatientIds = journeyData?.assignedPatients.map((a) => a.patientId.id) || [];
          const filteredPatient = patientData.filter((p) => !assignedPatientIds.includes(p.id));
          setPatients(filteredPatient);

          const newPatient = filteredPatient.find((p) => p.id === newPatientId);
          if (newPatient) {
            handlePatientSelect(newPatient);
          }
        }
      } catch (error) {
        notify("error", "Failed to load patients");
      } finally {
        setLoading(false);
      }
    }
  };


  const createPatient = async (patientData) => {
    
    
    try {
      setLoading(true);
      const response = await patientService.create(patientData);
      notify("success", "Patient Created Successfully.");
      setOpen(false);
      setLoading(false);
      fetchPatients();
    } catch (error) {
      if(error?.data?.message) {
        notify("error", error.data.message);

      }
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    if (!selectedPatient) {
      notify("warning", "Please select a patient");
      return;
    }

    const payload = {
      journeyId: journeyId,
      patientIds: [values.patientId],
      channel: values.channel,
      // reminderFreq: values.reminderFreq,
      message: values.message,
      // enableReminder: enableReminder,
      repeatUntil: values.repeatUntil ? values.repeatUntil.toISOString() : undefined,
      reminderFreq: enableReminder ? values.reminderFreq : "no reminder",
      scheduleDate:
        scheduleType === "immediate"
          ? new Date().toISOString()
          : values.scheduleDate
          ? values.scheduleDate.toISOString()
          : new Date().toISOString(),
    };

    // if (!values.journeyTemplate) {
    //   notify("warning", "Please select a journey template");
    //   return;
    // }

    try {
      setSubmitting(true);
      await journeyService.assignJourney(payload);
      notify("success", "Journey assigned successfully");
      if (onSuccess){
      onSuccess();
      }
      handleClose();
    } catch (error) {
      notify("error", "Failed to assign journey");
    } finally {
      setSubmitting(false);
    }
  };

  const fetchAllPhysician = async () => {
    try {
      const res = await physicianService.getAll(0,1,"","","");
      setAllPhysicians(res?.data?.results);
    } catch (error) {}
  };

  const fetchAllCoordinator = async () => {
    try {
      const res = await ccmCoordinatorService.getAll(0,1,"","","");
      setAllCoordinator(res?.data?.results);
    } catch (error) {}
  };

  useEffect(() => {
    if(user?.role === globalRoles?.SUPERADMIN || user?.role === globalRoles.LIBRARY_MANAGER){
      if(journeyData?.type === "clinical"){
        fetchAllPhysician();
      } else if(journeyData?.type === "ccm") {
        fetchAllCoordinator();
      }
    }
  }, []);

  const handleClose = () => {
    form.resetFields();
    setSelectedPatient(null);
    setSearchText("");
    setPatientSelectionType("existing");
    setEnableReminder(true);
    setScheduleType("immediate");
    setOpen(false);
    if(selectedClinicalId){
      setSelectedClinicalId("");
    }
  };

  const filteredPatients = patients.filter(
    (patient) =>
      patient.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      patient.email?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <ModelWrapper
        show={isOpen}
        setShow={handleClose}
        title={
          <div className="row-flex flex-column">
            <div className="font-18 font-semibold text-primary">
              Assign Journey to Patient
            </div>
          </div>
        }
        footer={null}
        width={650}
        keyClose={false}
        onCancel={handleClose}
        className="custom-detail-modal"
      >
        <ModalContent>
          <DescriptionText>
            Send 'Select a journey template' to a patient. They will receive
            access via email or SMS.
          </DescriptionText>

          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <SectionTitle>Select Patient</SectionTitle>

            <StyledRadioGroup
              value={patientSelectionType}
              onChange={(e) => {
                setPatientSelectionType(e.target.value);
                if (e.target.value === "new") {
                  setIsAddPatientModalOpen(true);
                } else {
                  setSelectedPatient(null);
                  form.setFieldsValue({ patientId: undefined });
                }
              }}
            >
              <Radio value="existing">Choose from existing patients</Radio>
              <Radio value="new">Add new patient</Radio>
            </StyledRadioGroup>

            {patientSelectionType === "existing" && (
              <>
                {selectedPatient ? (
                  <SelectedPatientBadge>
                    <SelectedPatientInfo>
                      <SelectedPatientName>{selectedPatient.name || "N/A"}</SelectedPatientName>
                      <SelectedPatientMeta>
                        {selectedPatient.email || "No email"} &nbsp;·&nbsp;{" "}
                        {selectedPatient.mobile?.number
                          ? `${selectedPatient.mobile?.countryCode || ""} ${selectedPatient.mobile?.number}`
                          : "No phone"}
                      </SelectedPatientMeta>
                    </SelectedPatientInfo>
                    <ChangePatientButton
                      type="button"
                      onClick={() => {
                        setSelectedPatient(null);
                        form.setFieldsValue({ patientId: undefined });
                        setSearchText("");
                      }}
                    >
                      Change
                    </ChangePatientButton>
                  </SelectedPatientBadge>
                ) : (
                  <>
                    <SearchInput
                      placeholder="Search patients by name or email..."
                      prefix={<SearchOutlined />}
                      value={searchText}
                      onChange={handleSearch}
                      allowClear
                    />
                    <PatientListContainer>
                      {loading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          Loading patients...
                        </div>
                      ) : filteredPatients.length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            color: "var(--secondary-text-color)",
                          }}
                        >
                          No patients found
                        </div>
                      ) : (
                        filteredPatients.map((patient) => (
                          <PatientCard
                            key={patient.id}
                            selected={selectedPatient?.id === patient.id}
                            onClick={() => handlePatientSelect(patient)}
                          >
                            <PatientName>{patient.name || "N/A"}</PatientName>
                            <PatientInfo>{patient.email || "No email provided"}</PatientInfo>
                            <PatientInfo>
                              {patient.mobile?.number
                                ? `${patient.mobile?.countryCode || ""} ${patient.mobile?.number}`
                                : "No phone provided"}
                            </PatientInfo>
                          </PatientCard>
                        ))
                      )}
                    </PatientListContainer>
                  </>
                )}
              </>
            )}

            {selectedPatient && (
              <>
                <SectionTitle>Delivery Settings <span style={{ color: "red" }}>*</span></SectionTitle>
                <Form.Item
                  name="channel"
                  initialValue="both"
                  rules={[{ required: true, message: "Please select notification type!" }]}
                >
                  <Radio.Group>
                    {sendMethodOptions.map((option) => (
                      <Radio key={option.value} value={option.value}>
                        {option.label}
                      </Radio>
                    ))}
                  </Radio.Group>
                </Form.Item>

                {/* <div style={{ marginTop: "4px", fontSize: "12px", color: "var(--secondary-text-color)" }}>
                  <CalendarOutlined style={{ marginRight: "4px" }} />
                  Email will be sent now. Reminders will be sent based on your selection.
                </div> */}

                <SectionTitle>Schedule</SectionTitle>
                <div style={{ marginBottom: "24px", border: "1px solid var(--border-color)", borderRadius: "6px", padding: "16px" }}>
                  <Form.Item
                    name="scheduleType"
                    initialValue="immediate"
                    style={{ marginBottom: scheduleType === "scheduled" ? "16px" : 0 }}
                  >
                    <StyledRadioGroup
                      value={scheduleType}
                      onChange={(e) => setScheduleType(e.target.value)}
                    >
                      <Radio value="immediate">Send immediately</Radio>
                      <Radio value="scheduled">Schedule for later</Radio>
                    </StyledRadioGroup>
                  </Form.Item>

                  {scheduleType === "scheduled" && (
                    <Form.Item
                      name="scheduleDate"
                      // label="Schedule Date & Time"
                      rules={[
                        {
                          required: true,
                          message: "Please select a date and time!",
                        },
                      ]}
                      style={{ marginBottom: 0 }}
                    >
                      <StyledDatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm"
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        disabledDate={(current) => {
                          return current && current < moment().startOf("day");
                        }}
                        placeholder="Select date and time"
                      />
                    </Form.Item>
                  )}
                </div>

                <div style={{ marginTop: "24px", marginBottom: "24px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontSize: "15px", fontWeight: "500" }}>Enable Reminder</div>
                    <Switch
                      checked={enableReminder}
                      onChange={(checked) => setEnableReminder(checked)}
                    />
                  </div>
                  <div style={{ fontSize: "14px", color: "var(--secondary-text-color)" }}>
                    Turn on to send emails at regular intervals
                  </div>
                </div>

                {enableReminder && (
                  <Row gutter={[16]}>
                    <Col span={12}>
                      <SectionTitle style={{ marginTop: 0 }}>Frequency</SectionTitle>
                      <Form.Item
                        name="reminderFreq"
                        // label="Frequency"
                        initialValue="weekly"
                      >
                        <StyledSelect
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          placeholder="Select frequency"
                          size="large"
                        >
                          {reminderFrequencyOptions.map((option) => (
                            <Option key={option.value} value={option.value}>
                              {option.label}
                            </Option>
                          ))}
                        </StyledSelect>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <SectionTitle style={{ marginTop: 0 }}>Repeat Until <span style={{ color: "red" }}>*</span></SectionTitle>
                      <Form.Item
                        name="repeatUntil"
                        rules={[{ required: true, message: "Please select end date!" }]}
                        style={{ marginBottom: 0 }}
                      >
                        <StyledDatePicker
                          placeholder="Select end date for frequency"
                          format="YYYY-MM-DD"
                          suffixIcon={<CalendarOutlined />}
                        />
                      </Form.Item>
                      <div style={{ marginTop: "4px", fontSize: "12px", color: "var(--secondary-text-color)" }}>
                         <CalendarOutlined style={{ marginRight: "4px" }} />
                         Emails will be sent until this date
                      </div>
                    </Col>
                  </Row>
                )}

                <SectionTitle>Custom Message (Optional)</SectionTitle>

                <Form.Item name="message">
                  <StyledTextArea
                    placeholder="Add a personal message to include with the journey..."
                    rows={4}
                  />
                </Form.Item>

                <Form.Item name="patientId" hidden>
                  <Input />
                </Form.Item>
              </>
            )}

            <ButtonContainer>
              <CustomSecondaryButton
                onClick={handleClose}
                disabled={submitting}
              >
                Cancel
              </CustomSecondaryButton>
              <Form.Item shouldUpdate>
                {() => (
                  <CustomButton
                    htmlType="submit"
                    loading={submitting}
                    disabled={
                      !selectedPatient 
                      // || !form.getFieldValue("journeyTemplate")
                    }
                    icon={<SendOutlined />}
                  >
                    {submitting ? "Assigning..." : "Assign Journey"}
                  </CustomButton>
                )}
              </Form.Item>
            </ButtonContainer>
          </Form>
        </ModalContent>
      </ModelWrapper>

      {isAddPatientModalOpen && (
        <AddPatientModal
          isOpen={isAddPatientModalOpen}
          setOpen={(val) => {
            setIsAddPatientModalOpen(val);
            if (!val) setPatientSelectionType("existing");
          }}
          isEdit={false}
          setEdit={() => {}}
          patientId={null}
          fetchPatient={fetchPatients}
          physicianList={journeyData?.type === "clinical" ? allPhysicians : journeyData?.type === "ccm" ? allCoordinator : []}
          userDetails={user}
          onPatientCreated={handlePatientCreated}
          ccm={journeyData?.type === "ccm"}
        />
      )}
    </>
  );
};

export default AssignJourneyModal;
